module.exports = __webpack_public_path__ + "img/Sakralbau_2_a.cff74753.jpg";